import { render } from "./footer.vue?vue&type=template&id=1af398f3"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/staging2/web_head/releases/20260804233255/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__